import { render, staticRenderFns } from "./foodBusinessLicense.vue?vue&type=template&id=d61375f2&scoped=true"
import script from "./foodBusinessLicense.vue?vue&type=script&lang=js"
export * from "./foodBusinessLicense.vue?vue&type=script&lang=js"
import style0 from "./foodBusinessLicense.vue?vue&type=style&index=0&id=d61375f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61375f2",
  null
  
)

export default component.exports